"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var errors_1 = require("@ledgerhq/errors");
var currencies_1 = require("../../currencies");
var account_1 = require("../../account");
var constants_1 = require("./constants");
var logic_1 = require("./logic");
var errors_2 = require("./errors");
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, totalSpent, totalSpentEgld, tokenAccount, formattedAmount, delegationBalance, delegationRemainingBalance, delegationBalanceForbidden, formattedAmount;
    var _a, _b;
    return __generator(this, function (_c) {
        errors = {};
        warnings = {};
        if (!t.recipient) {
            errors.recipient = new errors_1.RecipientRequired();
        }
        else if ((0, logic_1.isSelfTransaction)(a, t)) {
            errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
        }
        else if (!(0, logic_1.isValidAddress)(t.recipient)) {
            errors.recipient = new errors_1.InvalidAddress("", {
                currencyName: a.currency.name
            });
        }
        if (!t.fees) {
            errors.fees = new errors_1.FeeNotLoaded();
        }
        if (!errors.amount &&
            t.amount.eq(0) &&
            !t.useAllAmount &&
            !["unDelegate", "withdraw", "reDelegateRewards", "claimRewards"].includes(t.mode)) {
            errors.amount = new errors_1.AmountRequired();
        }
        totalSpent = new bignumber_js_1["default"](0);
        totalSpentEgld = new bignumber_js_1["default"](0);
        tokenAccount = (t.subAccountId &&
            a.subAccounts &&
            a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; })) ||
            null;
        if (tokenAccount) {
            totalSpent = t.amount;
            totalSpentEgld = t.fees || new bignumber_js_1["default"](0);
            if (!errors.amount && t.amount.gt(tokenAccount.balance)) {
                errors.amount = new errors_1.NotEnoughBalance();
            }
            if (!errors.amount &&
                !totalSpentEgld.decimalPlaces(constants_1.DECIMALS_LIMIT).isEqualTo(totalSpentEgld)) {
                errors.amount = new errors_2.ElrondDecimalsLimitReached();
            }
        }
        else {
            totalSpent = totalSpentEgld = (0, logic_1.isAmountSpentFromBalance)(t.mode)
                ? ((_a = t.fees) === null || _a === void 0 ? void 0 : _a.plus(t.amount)) || t.amount
                : t.fees || new bignumber_js_1["default"](0);
            if (t.mode === "send" && t.fees && t.amount.div(10).lt(t.fees)) {
                warnings.feeTooHigh = new errors_1.FeeTooHigh();
            }
            // All delegate and undelegate transactions must have an amount >= 1 EGLD
            if (!errors.amount && t.amount.lt(constants_1.MIN_DELEGATION_AMOUNT)) {
                formattedAmount = (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(a), constants_1.MIN_DELEGATION_AMOUNT, {
                    showCode: true
                });
                if (t.mode === "delegate") {
                    errors.amount = new errors_2.ElrondMinDelegatedAmountError("", {
                        formattedAmount: formattedAmount
                    });
                }
                else if (t.mode === "unDelegate") {
                    errors.amount = new errors_2.ElrondMinUndelegatedAmountError("", {
                        formattedAmount: formattedAmount
                    });
                }
            }
            delegationBalance = (_b = a.elrondResources.delegations.find(function (d) { return d.contract === t.recipient; })) === null || _b === void 0 ? void 0 : _b.userActiveStake;
            delegationRemainingBalance = new bignumber_js_1["default"](delegationBalance || 0).minus(t.amount);
            delegationBalanceForbidden = delegationRemainingBalance.gt(0) &&
                delegationRemainingBalance.lt(constants_1.MIN_DELEGATION_AMOUNT);
            if (!errors.amount &&
                t.mode === "unDelegate" &&
                delegationBalanceForbidden) {
                formattedAmount = (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(a), constants_1.MIN_DELEGATION_AMOUNT, {
                    showCode: true
                });
                errors.amount = new errors_2.ElrondDelegationBelowMinimumError("", {
                    formattedAmount: formattedAmount
                });
            }
        }
        if (!errors.amount && totalSpentEgld.gt(a.spendableBalance)) {
            errors.amount =
                tokenAccount || !["delegate", "send"].includes(t.mode)
                    ? new errors_2.NotEnoughEGLDForFees()
                    : new errors_1.NotEnoughBalance();
        }
        return [2 /*return*/, Promise.resolve({
                errors: errors,
                warnings: warnings,
                estimatedFees: t.fees || new bignumber_js_1["default"](0),
                amount: t.amount,
                totalSpent: totalSpent
            })];
    });
}); };
exports["default"] = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map